import i18n from '@/helpers/i18n';

export default [
  {
    _name: 'CSidebarNav',
    _children: [ 
      {
        _name: 'CSidebarNavTitle',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('heros'),
        to: '/' + i18n.t('heros') + '/' + i18n.t('list'),
        icon: 'cil-library',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('projects'),
        to: '/' + i18n.t('projects') + '/' + i18n.t('list'),
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('services'),
        to: '/' + i18n.t('services') + '/' + i18n.t('list'),
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('keyValuesMenu'),
        to: '/' + i18n.t('keyValues') + '/' + i18n.t('list'),
        icon: 'cil-library',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('staticInfosMenu'),
        to: '/' + i18n.t('staticInfos') + '/' + i18n.t('list'),
        icon: 'cil-File',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('profile'),
        to: '/' + i18n.t('profile'),
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('logout'),
        to: '/logout',
        icon: 'cil-power-standby'
      },
      {
        _name: 'CSidebarNavTitle',
      }
    ]
  }
]